import Vue from 'vue'
import cloneDeep from 'lodash/cloneDeep'
import moment from 'moment'
import api from '@/api'
import c from '@/config'
import storejs from 'store'

const isUniFrameRange = storejs.get('label:isUniFrameRange')

const state = {
  // label
  drawType: 'positive_default',
  labelList: [],
  selectedLabel: null,
  frameRange: c.defaultFrameRange,
  labelComment: '',

  clothAssessment: {},

  labelStat: {},

  lineShieldTime: '1|hours',

  isUniFrameRange: isUniFrameRange === undefined ? true : isUniFrameRange,
}
const getters = {
  isFrameInRange(state, getters, rootState) {
    return (
      rootState.frameIdx >= state.frameRange[0] &&
      rootState.frameIdx <= state.frameRange[1]
    )
  },
  labelList(state, getters, rootState) {
    let labelList = state.labelList
    if (
      state.selectedLabel !== null &&
      state.selectedLabel >= 0 &&
      state.selectedLabel < labelList.length
    ) {
      labelList = cloneDeep(state.labelList)
      labelList[state.selectedLabel].active = true
    }
    labelList = labelList.map((item, idx) => {
      item.idx = idx
      return item
    })
    return labelList.filter(
      label =>
        rootState.frameIdx >= label.frameRange[0] &&
        rootState.frameIdx <= label.frameRange[1],
    )
  },
  curBaseLayer(state, getters, rootState) {
    const decodedVideo = rootState.decodedVideo
    if (decodedVideo.bufferArray.length > 0) {
      return {
        type: 'YUVBuffer',
        source: decodedVideo.bufferArray[rootState.frameIdx],
        width: decodedVideo.bufferWidth,
        height: decodedVideo.bufferHeight,
      }
    }
    return null
  },
  curLayerData(state, getters, rootState) {
    const result = []
    // Detected result
    // 由于解码时会固定丢失前面几帧非关键帧，decodedVideo 和 detectInfo 数量不总是一致的，因此需要将detectInfo向右平移，对齐图像
    const alignment = rootState.detectInfo.length - rootState.frameCount
    const detectInfoData = rootState.detectInfo[rootState.frameIdx + alignment]
    if (detectInfoData) {
      result.push({ type: 'DETECT_RESULT', data: detectInfoData })
    }

    // line Shield
    let lineShieldData = null
    if (rootState.showRealtimeShieldLine) {
      lineShieldData = rootState.realtimeShieldInfo.line
    } else {
      const lineShield = rootState.shieldInfo.line
      if (lineShield) {
        lineShieldData = lineShield
      }
    }
    // HACK: VUEX getters 数组不刷新
    if (rootState.refresh) {
      result.push({ type: 'SHIELD_LINE', data: lineShieldData })
    } else {
      result.push({ type: 'SHIELD_LINE', data: lineShieldData })
    }

    // manually Shield
    let manuallyShieldData = null
    if (rootState.showRealtimeShieldManually) {
      manuallyShieldData = rootState.realtimeShieldInfo.manually
    } else {
      const manuallyShield = rootState.shieldInfo.manually
      if (manuallyShield && !(manuallyShield instanceof Array)) {
        manuallyShieldData = manuallyShield
      }
    }
    // HACK: VUEX getters 数组不刷新
    if (rootState.refresh) {
      result.push({ type: 'SHIELD_MANUALLY', data: manuallyShieldData })
    } else {
      result.push({ type: 'SHIELD_MANUALLY', data: manuallyShieldData })
    }

    // LABEL
    result.push({ type: 'LABEL', data: getters.labelList })
    return result
  },
  tools(state, getters, rootState) {
    const result = []
    if (rootState.showMagnifier) {
      result.push({ name: 'TOOL_MAGNIFIER', diameter: rootState.diameter })
    }

    // draw
    if (
      state.drawType.startsWith('positive') ||
      state.drawType.startsWith('negative')
    ) {
      if (getters.isFrameInRange) {
        result.push({
          name: 'TOOL_DRAW_LABEL',
          type: state.drawType,
          minLength: 10,
        })
      }
    } else if (state.drawType === 'SHIELD_MANUALLY') {
      result.push({ name: 'TOOL_DRAW_SHIELD_MANUALLY', type: state.drawType })
    } else if (state.drawType.startsWith('SHIELD_LINE')) {
      result.push({ name: 'TOOL_DRAW_SHIELD_LINE', type: state.drawType })
    }

    // inspect line shield
    if (rootState.showRealtimeShieldLine) {
      result.push({
        name: 'TOOL_INSPECT_SHIELD_LINE',
        data: rootState.realtimeShieldInfo.line,
      })
    }
    result.push({
      name: 'TOOL_INSPECT_LABEL',
      bias: 20,
      data: getters.labelList.map(label => {
        label.shape = c.labelTypes[label.type].shape
        return label
      }),
    })

    return result
  },
}
const mutations = {
  setLabelList(state, labelList) {
    state.labelList = labelList
  },
  addLabel(state, label) {
    label.frameRange = state.frameRange
    state.labelList.push(label)
  },
  deleteLabelById(state, idx) {
    state.labelList.splice(idx, 1)
    state.selectedLabel = idx - 1 < 0 ? 0 : idx - 1
  },
  setSelectedLabel(state, selectedLabel) {
    state.selectedLabel = selectedLabel
  },
  setLabelListFrameRange(state) {
    const frameRange = state.frameRange
    // force set all label frame range
    if (state.isUniFrameRange) {
      state.labelList = state.labelList.map(label => {
        label.frameRange = frameRange
        return label
      })
    } else {
      const selectedLabel = state.labelList[state.selectedLabel]
      if (selectedLabel) {
        selectedLabel.frameRange = frameRange
      }
    }
  },
  setLabelComment(state, labelComment) {
    state.labelComment = labelComment
  },
  setlabelers(state, labelers) {
    state.labelers = labelers
  },

  setClothAssessment(state, clothAssessment) {
    state.clothAssessment = clothAssessment
  },

  setLabelStat(state, labelStat) {
    state.labelStat = labelStat
  },

  setFrameRange(state, frameRange) {
    state.frameRange = frameRange
  },
  resetAll(state) {
    Vue.set(state, 'drawType', 'positive_default')
    Vue.set(state, 'labelList', [])
    Vue.set(state, 'labelComment', '')
    Vue.set(state, 'clothAssessment', {})
    Vue.set(state, 'selectedLabel', null)
  },
}
const actions = {
  fetchLabelList({ commit, state, getters, rootState, rootGetters }) {
    commit('setLabelList', [])
    commit('setLabelComment', '')
    const result = {}
    const clothAssessmentConfig = rootState.clothAssessmentConfig
    Object.keys(clothAssessmentConfig).forEach(key => {
      if (
        result[key] === undefined &&
        clothAssessmentConfig[key].default !== undefined
      ) {
        result[key] = clothAssessmentConfig[key].default
      }
    })
    commit('setClothAssessment', result)
    commit('setFrameRange', c.defaultFrameRange)
    api
      .getLabelList({ tarId: rootState.tarId, cameraId: rootGetters.cameraId })
      .then(({ status, data }) => {
        if (status === 200) {
          let labelData = []
          try {
            labelData = JSON.parse(data.labelData)
          } catch (e) {
            console.log('Parse label list error', e)
          }
          const labelList = labelData.map(label => {
            return {
              type: `${label.type}_${label.typeDetail}`,
              frameRange: [label.startIndex, label.endIndex],
              area: label.position,
            }
          })
          commit('setLabelList', labelList)
          commit('setLabelComment', data.labelComment)
          Object.keys(clothAssessmentConfig).forEach(key => {
            if (
              data.clothAssessment[key] === undefined &&
              clothAssessmentConfig[key].default !== undefined
            ) {
              data.clothAssessment[key] = clothAssessmentConfig[key].default
            }
          })
          commit('setClothAssessment', data.clothAssessment)
          commit('setLabelStat', data)
          // init global frame range
          // commit(
          //   'setFrameRange',
          //   labelList.length > 0
          //     ? labelList[0].frameRange
          //     : c.defaultFrameRange,
          // )
        } else {
          commit('setLabelStat', {})
        }
      })
  },
  pushLabelList({ commit, state, getters, rootState, rootGetters }) {
    return new Promise((resolve, reject) => {
      if (rootState.privileges.LabelingBasic) {
        const labelData = state.labelList.map(label => {
          const typeArr = label.type.split('_')
          return {
            type: typeArr[0],
            typeDetail: typeArr[1],
            startIndex: label.frameRange[0],
            endIndex: label.frameRange[1],
            position: label.area,
          }
        })

        api
          .putLabelList({
            tarId: rootState.tarId,
            cameraId: rootGetters.cameraId,
            data: {
              labelData: JSON.stringify(labelData),
              labelComment: state.labelComment,
              clothAssessment: state.clothAssessment,
              detectionMachineId: /detectionData\/([^/]+)/.exec(
                rootGetters.tarUrl,
              )[1],
            },
          })
          .then(resolve)
          .catch(reject)
      } else {
        reject(new Error("You don't have labeling privalege."))
      }
    })
  },
  handleToolEvent({ state, commit, rootState, rootGetters }, data) {
    const cameraName = `camera${String(rootGetters.cameraId).padStart(2, '0')}`
    switch (data.type) {
      case 'DRAW_LABEL':
        const { offsetX: x1, offsetY: y1 } = data.start
        const { offsetX: x2, offsetY: y2 } = data.end
        const { width, height } = data.options
        // draw label
        commit('addLabel', {
          area: [x1 / width, y1 / height, x2 / width, y2 / height],
          type: state.drawType,
        })
        rootState.modified = true
        break
      case 'DRAW_SHIELD_MANUALLY':
        data.idxs.forEach(idx => {
          rootState.realtimeShieldInfo.manually.shield[idx] = data.delete
            ? 0
            : 1
        })
        commit('refresh', null, { root: true })
        break
      case 'DRAW_SHIELD_LINE':
        let endAt = null
        if (state.drawType === 'SHIELD_LINE_TIME') {
          const timeArray = state.lineShieldTime.split('|')
          endAt = parseInt(
            moment()
              .utcOffset('+08:00')
              .add(timeArray[0], timeArray[1])
              .format('YYYYMMDDHHmmss'),
          )
        }
        data.idxs.forEach(idx => {
          const blindItem = {
            blindIndex: idx,
            cameraName,
            isPermanent: true,
            site: 'biaozhu',
            username: rootState.userInfo.UserName,
          }
          if (endAt !== null) {
            blindItem.endAt = endAt
            blindItem.isPermanent = false
          }
          const curIdx = rootState.realtimeShieldInfo.line.findIndex(
            item => item.blindIndex === idx,
          )
          if (curIdx === -1) {
            if (data.delete) {
            } else {
              // add
              rootState.realtimeShieldInfo.line.push(blindItem)
            }
          } else {
            if (data.delete) {
              rootState.realtimeShieldInfo.line.splice(curIdx, 1)
            } else {
              // modi
              rootState.realtimeShieldInfo.line[curIdx] = blindItem
            }
          }
        })
        commit('refresh', null, { root: true })
        break
      case 'INSPECT_LABEL':
        state.selectedLabel = data.index
        break
      default:
        console.log(data)
    }
  },
  deleteLabel({ rootState, rootGetters, dispatch }) {
    return new Promise((resolve, reject) => {
      api
        .deleteLabel({
          tarId: rootState.tarId,
          cameraId: rootGetters.cameraId,
        })
        .then(() => {
          dispatch('fetchLabelList')
          resolve()
        })
        .catch(reject)
    })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
